module.exports = __webpack_public_path__ + "img/xlxr.893c9526.png";